import { render, staticRenderFns } from "./SPRPillList.vue?vue&type=template&id=6e19c5a8"
import script from "./SPRPillList.vue?vue&type=script&lang=js"
export * from "./SPRPillList.vue?vue&type=script&lang=js"
import style0 from "./SPRPillList.vue?vue&type=style&index=0&id=6e19c5a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports